import { render } from "./Zhibo.vue?vue&type=template&id=050b030c&scoped=true"
import script from "./Zhibo.vue?vue&type=script&lang=js"
export * from "./Zhibo.vue?vue&type=script&lang=js"

import "./Zhibo.vue?vue&type=style&index=0&id=050b030c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-050b030c"

export default script